import { render } from "./PriceExamplesBlock.vue?vue&type=template&id=9f2cef38&scoped=true"
import script from "./PriceExamplesBlock.vue?vue&type=script&lang=js"
export * from "./PriceExamplesBlock.vue?vue&type=script&lang=js"

import "./PriceExamplesBlock.vue?vue&type=style&index=0&id=9f2cef38&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9f2cef38"
/* hot reload */
if (module.hot) {
  script.__hmrId = "9f2cef38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f2cef38', script)) {
    api.reload('9f2cef38', script)
  }
  
  module.hot.accept("./PriceExamplesBlock.vue?vue&type=template&id=9f2cef38&scoped=true", () => {
    api.rerender('9f2cef38', render)
  })

}

script.__file = "src/components/blocks/PriceExamplesBlock.vue"

export default script